import { CountUp } from 'countup.js'
import $ from 'jquery'

$(document).ready(function() {
	const $ourFigure = $('.brief-info')
	if ($ourFigure.length) {
		const shouldCalls = [] //store functions
		$ourFigure.each(function() {
			let countUps = []
			$(this)
				.find('.brief-info-number')
				.each(function() {
					countUps.push(new CountUp($(this).attr('id'), $(this).attr('data-store')))
				})

			// Scroll detect
			let countedFlag = false
			const ourFigureHeight = $(this).outerHeight()
			const ourFigureTop = $(this).offset().top
			const checkAndRun = () => {
				if (
					!countedFlag &&
					$(window).scrollTop() >
						ourFigureTop + ourFigureHeight - $(window).height() - 40
				) {
					countUps.forEach(function(target, index) {
						target.start(0)
					})
					//update the state
					countedFlag = true
				}
			}
			shouldCalls.push(checkAndRun)
		})

		const checkAll = () => {
			shouldCalls.forEach(func => {
				if (typeof func == 'function') {
					func()
				}
			})
		}

		//Initialise
		checkAll()
		$(window).on('scroll', function() {
			checkAll()
		})
	}
})
